export const ukrMenu = {
  account: 'https://my.nova.global?lang=ua-uk',
  list: [
    { title: 'Хто ми', link: '/about' },
    { title: 'Продукти і сервіси', link: '/products-services' },
    { title: 'Шопінг', link: 'https://npshopping.com' },
    { title: 'Трекінг', link: '/track/' },
  ],
  track: '/track/',
}

export const ruMenu = {
  account: "https://my.nova.global?lang=ua-ru",
  list: [
    { title: "Кто мы", link: "/ru/about/" },
    { title: "Продукты и сервисы", link: "/ru/products-services/" },
    { title: "Шопинг", link: "https://npshopping.com" },
    { title: "Трекинг", link: "/ru/track/" },
  ],
  track: "/ru/track/",
};

export const enMenu = {
  account: "https://my.nova.global?lang=ua-en",
  list: [
    { title: "Who we are", link: "/en/about" },
    { title: "Products and services", link: "/en/products-services" },
    { title: "Shopping", link: "https://npshopping.com" },
    { title: "Tracking", link: "/en/track/" },
  ],
  track: "/en/track/",
};
